module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAR9JREFUOE+9lLFOAkEQhr9ZhA5tfAN9ACklvoKYmKixtbcyOTqMdl5idb0vgJocPoCJdlroA+gb2KCdBzsGPeBYDzW4ue12Z/eb+WdmR/C8xDOP4oC6frCImdsHbQBLqZJnkA62F8nV6UueutwItRFsIpwBC1NS0kXZk0546dq/AVNYGzC/5NeibLnQCeCXzNLTD5G5PrrY/nJW/iRwo3kE2hq9Eq1hJUJYS8+usf0mpnQ3JsuxxCeHw70DDB6AlUwYtyS6TcW0Udujwi7vMsjbaubOo8RhbRrwFag6um5IdOfzrGwuQOuO/U3icL4wYL7kspyDJjNIziuKiRAdF0UJEO7/VhTfbTPw6rWxhzK8fr0R1Odw+M+MLG4ezhrlB7XKiRUyqr5+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_cancel.png
// module id = Nqnm
// module chunks = 1